export let OrgRelationshipModalFieldsJSON = {
  "1719383722105-customSelect": {
    elementid: 1719383722105,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687656-textfield": {
    elementid: 1719383687656,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383715621-textarea": {
    elementid: 1719383715621,
    elementtype: "textarea",
    "display-fieldlabel": "Description",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
  },
};
